<template>
  <div style="padding:50px 0; background:#f5f7fa;">
    <div class="container">
  <!-- 关于我们 标题与简介 -->
      <h2 style="text-align:center;margin:0 0 40px;color:#304156;font-size:34px;">关于我们</h2>

      <!--企业·文化：使命愿景 + 价值观 -->
      <section class="culture-section">
        <h2 class="culture-title">企业文化</h2>
        <div class="title-underline"><span></span></div>
        <div class="culture-card">
          <!-- 左：使命愿景覆盖图文 -->
          <div class="mission-panel" :style="{ backgroundImage: 'url(' + earthBg + ')' }">
            <div class="mission-overlay"></div>
            <div class="mission-inner">
              <div class="mission-label">
                <span>使命愿景</span>
                <i class="mission-line"></i>
                <i class="mission-line short"></i>
                <i class="mission-line tiny"></i>
              </div>
              <div class="mission-text">
                <div class="t1">成为国内顶尖的</div>
                <div class="t2">科技赋能型</div>
                <div class="t3">资产管理机构</div>
              </div>
            </div>
          </div>

          <!-- 右：价值观三列 -->
          <div class="values-panel">
            <div class="values-header">价值观</div>
            <div class="values-underline">
              <span class="bar"></span><span class="bar"></span><span class="bar"></span><span class="bar"></span>
            </div>
            <div class="values-list">
              <div class="value-item">
                <div class="icon"><i class="fa fa-shield"></i></div>
                <div class="title">守正</div>
                <ul>
                  <li>坚守原则</li>
                  <li>依法合规</li>
                </ul>
              </div>
              <div class="value-item">
                <div class="icon"><i class="fa fa-road"></i></div>
                <div class="title">行稳</div>
                <ul>
                  <li>稳健推进</li>
                  <li>风险可控</li>
                </ul>
              </div>
              <div class="value-item">
                <div class="icon"><i class="fa fa-warning"></i></div>
                <div class="title">持忧</div>
                <ul>
                  <li>居安思危</li>
                  <li>预案先行</li>
                </ul>
              </div>
              <div class="value-item">
                <div class="icon"><i class="fa fa-line-chart"></i></div>
                <div class="title">明势</div>
                <ul>
                  <li>洞察趋势</li>
                  <li>数据研判</li>
                </ul>
              </div>
              <div class="value-item">
                <div class="icon"><i class="fa fa-users"></i></div>
                <div class="title">共荣</div>
                <ul>
                  <li>共创价值</li>
                  <li>协同成长</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 一分钟了解中政量化 -->
      <section class="overview-section" style="margin: 0 0 80px;">
        <div class="overview-card">
          <div class="overview-top">
            <div class="overview-image">
              <img src="/zhuyetupian.jpg" alt="研究院环境" />
            </div>
            <div class="overview-content">
              <div class="mini-label">一分钟</div>
              <h3 class="overview-title">了解中政量化</h3>
              <div class="overview-underline"></div>
              <p class="overview-desc">中政量化投资成立于2022年10月，创始团队于2009年开始致力于量化投资和程序化交易领域的研究，核心人员均具有10年以上量化策略研究、交易风控经验。⽬前团队已形成⼈⼯智能量化模型框架，包括时序模型、多因⼦模型和事件驱动模型。在选股、择时、因⼦、⻛控⼏个⽅⾯均形成策略框架，我们致⼒于成为⼈⼯智能驱动型量化投资公司。通过先进的⼈⼯智能算法和⼤数据分析，为投资者提供⾼效、稳定的量化投资产品
              </p>
              <div class="feature-list">
                <div class="feature-item">
                  <div class="fi-icon"><i class="fa fa-database"></i></div>
                  <div class="fi-text">
                    <h4>数据驱动</h4>
                    <p>多源异构数据系统化采集与清洗, 支撑高频与日频策略研发</p>
                  </div>
                </div>
                <div class="feature-item">
                  <div class="fi-icon"><i class="fa fa-line-chart"></i></div>
                  <div class="fi-text">
                    <h4>多策略协同</h4>
                    <p>Alpha / CTA / 因子轮动 / 事件驱动组合化降低相关性</p>
                  </div>
                </div>
                <div class="feature-item">
                  <div class="fi-icon"><i class="fa fa-shield"></i></div>
                  <div class="fi-text">
                    <h4>体系化风控</h4>
                    <p>分层风险指标+实时监控+场景压力测试, 守住回撤底线</p>
                  </div>
                </div>
                <div class="feature-item">
                  <div class="fi-icon"><i class="fa fa-cogs"></i></div>
                  <div class="fi-text">
                    <h4>工程化研究</h4>
                    <p>统一特征仓+回测框架+自动化流水线, 缩短策略上市周期</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="overview-stats">
            <div class="stat-item">
              <div class="stat-number">8+</div>
              <div class="stat-label">核心研究成员</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">8+</div>
              <div class="stat-label">平均策略方向</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">100+</div>
              <div class="stat-label">在研/验证策略</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">低相关</div>
              <div class="stat-label">组合相关性目标</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">全流程</div>
              <div class="stat-label">数据→执行闭环</div>
            </div>
          </div>
        </div>
      </section>




    </div>
  </div>
</template>
<script>

export default {
  name: 'AboutUsComponent',
  components:{},
  data(){
    return {
      earthBg: require('@/assets/default-environment.jpg')
    }
  }
}
</script>

<style scoped>

.culture-section { margin: 0 0 70px; }
.culture-title { text-align: center; font-size: 28px; color: #3d5fbf; margin: 0; }
.title-underline { display: flex; justify-content: center; margin: 10px 0 26px; }
.title-underline span { display: inline-block; width: 80px; height: 4px; background: #2f54eb; border-radius: 2px; }

.culture-card { background: #fff; border-radius: 10px; box-shadow: 0 10px 30px rgba(0,0,0,.06); display: grid; grid-template-columns: 1.2fr 1fr; overflow: hidden; }
.mission-panel { position: relative; min-height: 360px; background-size: cover; background-position: center; }
.mission-overlay { position: absolute; inset: 0; background: rgba(10,25,61,.55); }
.mission-inner { position: relative; z-index: 1; color: #fff; padding: 42px 34px; height: 100%; display: flex; flex-direction: column; justify-content: center; }
.mission-label { display: flex; align-items: center; gap: 10px; margin-bottom: 16px; opacity: .95; }
.mission-label span { font-size: 16px; letter-spacing: 2px; }
.mission-line { display: inline-block; height: 2px; background: #dbe5ff; width: 120px; opacity: .8; }
.mission-line.short { width: 70px; }
.mission-line.tiny { width: 40px; }
.mission-text .t1 { font-size: 22px; font-weight: 700; margin-bottom: 6px; }
.mission-text .t2 { font-size: 44px; font-weight: 900; margin: 8px 0; letter-spacing: 2px; }
.mission-text .t3 { font-size: 26px; font-weight: 800; }

.values-panel { padding: 34px 32px; }
.values-header { color: #304156; font-size: 18px; font-weight: 700; margin-bottom: 12px; }
.values-underline { display: flex; gap: 12px; margin-bottom: 18px; }
.values-underline .bar { height: 2px; background: #304156; flex: 1; opacity: .6; }
.values-list { display: grid; grid-template-columns: repeat(5,1fr); gap: 24px; margin-top: 8px; }
.value-item { text-align: center; }
.value-item .icon { font-size: 34px; color: #304156; margin: 8px 0 10px; }
.value-item .title { font-size: 16px; color: #304156; font-weight: 600; margin-bottom: 6px; }
.value-item ul { list-style: disc; padding-left: 18px; text-align: left; color: #606266; }
.value-item li { margin: 6px 0; }

@media (max-width: 1024px) {
  .culture-card { grid-template-columns: 1fr; }
  .values-list { grid-template-columns: repeat(3,1fr); }
  .culture-section { margin: 0 0 50px; }
}
@media (max-width: 640px) {
  .mission-text .t2 { font-size: 32px; }
  .values-list { grid-template-columns: repeat(2,1fr); }
  .culture-title { font-size: 24px; }
  .mission-inner { padding: 30px 20px; }
  .values-panel { padding: 24px 20px; }
  .container { padding: 0 20px; }
  /* 添加以下样式确保标题不被遮挡 */
  .culture-section { margin-top: 20px; }
  .culture-title { margin-bottom: 15px; }
}
@media (max-width: 480px) {
  .culture-title { font-size: 22px; }
  .mission-text .t1 { font-size: 18px; }
  .mission-text .t2 { font-size: 28px; }
  .mission-text .t3 { font-size: 22px; }
  .values-list { grid-template-columns: 1fr; }
}

/* 一分钟了解中政量化样式 */
.overview-section {
  padding: 0;
}

.overview-card {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 4px 18px rgba(0,0,0,.06);
  overflow: hidden;
}

.overview-top {
  display: flex;
  flex-direction: row;
}

.overview-image {
  width: 34%;
  min-height: 420px;
  position: relative;
  overflow: hidden;
}

.overview-image img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overview-content {
  flex: 1;
  padding: 54px 64px 48px;
  background: linear-gradient(180deg,#ffffff 0%,#f8fafc 100%);
}

.mini-label {
  font-size: 14px;
  color: #1d5fad;
  margin-bottom: 4px;
  letter-spacing: 1px;
}

.overview-title {
  font-size: 28px;
  color: #114576;
  margin: 0 0 14px;
  font-weight: 600;
}

.overview-underline {
  width: 84px;
  height: 4px;
  background: #1d5fad;
  border-radius: 2px;
  margin-bottom: 28px;
}

.overview-desc {
  font-size: 15px;
  line-height: 1.9;
  color: #4c5b66;
  margin: 0 0 32px;
  white-space: pre-line;
}

.feature-list {
  display: grid;
  grid-template-columns: repeat(2,minmax(220px,1fr));
  gap: 32px 40px;
  margin-bottom: 30px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.fi-icon {
  font-size: 30px;
  color: #2f6fd0;
  line-height: 1;
}

.fi-text h4 {
  margin: 0 0 6px;
  font-size: 15px;
  color: #18354d;
  font-weight: 600;
}

.fi-text p {
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: #5d6d79;
}

.overview-cta {
  margin-top: 6px;
}

.overview-stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 38px 40px 34px;
  border-top: 1px solid #eef1f5;
  background: #fff;
}

.stat-item {
  min-width: 120px;
  margin: 0 10px 18px;
}

.stat-number {
  font-size: 30px;
  font-weight: 600;
  color: #0d4e9c;
  letter-spacing: 1px;
}

.stat-label {
  font-size: 13px;
  color: #5d6d79;
  margin-top: 4px;
  letter-spacing: .5px;
}

/* 响应式设计 */
@media (max-width: 1100px) {
  .overview-top {
    flex-direction: column;
  }
  
  .overview-image {
    width: 100%;
    min-height: 300px;
  }
  
  .overview-content {
    padding: 40px 42px 36px;
  }
  
  .overview-stats {
    padding: 32px 32px 24px;
  }
  
  .stat-item {
    min-width: 100px;
  }
}

@media (max-width: 640px) {
  .overview-content {
    padding: 34px 28px 30px;
  }
  
  .overview-title {
    font-size: 24px;
  }
  
  .feature-list {
    grid-template-columns: repeat(2,1fr);
    gap: 20px 18px;
  }
  
  .stat-number {
    font-size: 24px;
  }
  
  .overview-desc {
    font-size: 14px;
  }
}

@media (max-width: 520px) {
  .feature-list {
    grid-template-columns: 1fr;
  }
}
</style>